var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWateringCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55264 7.60369C6.69775 8.10441 6.33083 9.163 6.68867 10.0963L9.98956 18.7058C10.4339 19.8647 11.7919 20.3492 12.8535 19.7274L20.94 14.991C22.0016 14.3693 22.2671 12.9339 21.4999 11.964L20.6213 10.8533C21.9872 9.83665 22.4137 7.88547 21.5577 6.33981C20.6472 4.69574 18.6298 4.13171 17.0519 5.0815L17.0325 5.09316L16.4521 5.49375L17.3529 6.69771L17.8011 6.38834C18.6764 5.8748 19.7876 6.18993 20.2916 7.09996C20.7858 7.99232 20.5132 9.12632 19.6882 9.67371L15.8008 4.75922C15.183 3.97817 14.0958 3.77123 13.2409 4.27195L7.55264 7.60369Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.3269V17.8203C2 18.6753 2.91413 19.1854 3.59659 18.7111L4.62354 17.9973C4.74487 17.913 4.84562 17.8042 4.92139 17.6795C5.02404 17.5106 5.08084 17.3125 5.08084 17.1065V15.0407C5.08084 14.8347 5.02404 14.6366 4.92139 14.4677C4.84562 14.343 4.74487 14.2342 4.62354 14.1499L3.59659 13.4361C2.91413 12.9618 2 13.4718 2 14.3269Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97815 17.6075L8.50001 17.6045L7.23438 14.4677H5.97815V17.6075Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWateringCan);
export default __webpack_public_path__ + "static/media/watering-can.4f61e72b1cb50d1b1bd83052a3cc4fe3.svg";
export { ForwardRef as ReactComponent };